module.exports = "/static/assets/f368eb36724d400b79a10cd5abf90697.png";